import script from "./ExpandableText.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpandableText.vue?vue&type=script&setup=true&lang=ts"

import "./ExpandableText.vue?vue&type=style&index=0&id=db69d40a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db69d40a"]])

export default __exports__